import styled from 'styled-components';

export const button = styled.div`
  margin-bottom: 6px;
  margin-right: 6px;
  max-width: 250px;
`;
